import { Trans, useTranslation } from "react-i18next";
import FooterBlock from "../../components/Footer/Footer";
import "./LandingPage.scss";
import Divider from "../../components/Decors/Divider/Divider";
import FullPageDivider from "../../components/Decors/FullPageDivider/FullPageDivired";

const LandingPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className={"pageBlock scroll"}>
        <div
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL + "/images/landing-bg.jpg"
            })`,
          }}
          className={
            "background-image startBellowNavbar pageBlockLandingImage scroll"
          }
        >
          <h1 className="title">
            <Trans i18nKey="landing.title" components={{ br: <br /> }} />
          </h1>
          <div className="overlay"></div>
        </div>
        <FullPageDivider className="landing-divider" />
      </section>
      <section className={"background-grad-copper"}>
        <div className="slanted-left-top background-grad-blue scroll">
          <div className="left-block">
            <h2 className="landing-h2-copper">{t("landing.block1Title")}</h2>
            <Divider />
            <p className="lightText">{t("landing.block1Text")}</p>
          </div>
        </div>
      </section>
      <section className={"background-grad-blue"}>
        <div className="slanted-right background-grad-copper scroll">
          <div className="right-block">
            <h2 className="landing-h2-blue">{t("landing.block2Title")}</h2>
            <Divider />
            <p className="darkText">{t("landing.block2Text")}</p>
          </div>
        </div>
      </section>
      <section className={"background-grad-copper scroll"}>
        <div className="slanted-left background-grad-blue">
          <div className="left-block">
            <h2 className="landing-h2-copper">{t("landing.block3Title")}</h2>
            <Divider />
            <p className="lightText">{t("landing.block3Text")}</p>
          </div>
        </div>
      </section>
      <FooterBlock canScroll="scroll" />
    </>
  );
};

export default LandingPage;
